import InsureProcessTravel from './InsureProcessTravel';
export default InsureProcessTravel;
